import {Item} from "../../models/Item";
import {AbstractMainPlugin} from "../AbstractMainPlugin";
import {ObjectConfig} from "../../models/ObjectConfig";
import {isDisableW3W} from "../../../configs/view_only";


export class W3wObjectsPlugin extends AbstractMainPlugin {

  constructor(item:Item) {
    super(item);

    this.initListeners();
  }

  private assignW3WInput(){
    let input = {"label":"w3w","calculation":"return _3words(item.objects[0].position.lat(), item.objects[0].position.lng());"};
    this.item.config.assignInput('w3w', input);
  }

  private initListeners() {
    if (!isDisableW3W) {
      let w3wInput = this.item.config.getInputByName('w3w');
      if (!w3wInput) {
        if (this.item.config.getTool().type == ObjectConfig.TYPE_FIXED_FIGURE) {
          this.assignW3WInput();
        }
      }
    }
  }

}
